import React, { useState } from "react";
import CookieConsent from "../CookieConsent/CookieConsent";
import Footer from "../Auth/Footer";
import styles from "./privacypolicy.module.css";
const PrivacyPolicy = (props) => {
return (
    <>
    <main>
      <div className={`${styles.contentWrapper}  ${styles.spacing} mt-8`}>
        <section className={ styles.section }>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}>
              <h1 className={`${styles.h1}`}><strong>RocketPages Privacy Policy</strong></h1>
            </div>
            <div className={`${styles.description}`}>
              <br />
              <p><strong>Last updated: May 17, 2024</strong></p>

              <p>
                RocketPages ("us", "we", or "our") operates <strong>[your website URL] (the "Site"). </strong>This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site.We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.</p></div>
          </div>
      </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Information Collection and Use</strong></h3></div>
            <div  className={`${styles.description}  ${styles.fsmd}`}><p>While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include but is not limited to your name <strong>("Personal Information")</strong>.</p></div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Log Data</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>Like many site operators, we collect information that your browser sends whenever you visit our Site <strong>("Log Data")</strong>.</p><p>This Log Data may include information such as your computer's Internet Protocol <strong>("IP")</strong> address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p><p>In addition, we may use third-party services such as Google Analytics that collect, monitor, and analyze this data.</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Communications</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>We may use your Personal Information to contact you with newsletters, marketing, or promotional materials and other information that may be of interest to you. You may opt-out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Cookies</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p><p>Like many sites, we use <strong>"cookies"</strong> to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Security</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Changes to This Privacy Policy</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>This Privacy Policy is effective as of [Date] and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p><p>We reserve the right to update or change our Privacy Policy at any time, and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p><p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us or by placing a prominent notice on our website.</p>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div>
            <div className={`${styles.title}  ${styles.fsmd}`}><h3><strong>Contact Us</strong></h3></div>
            <div className={`${styles.description}  ${styles.fsmd}`}>
            <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@rocketpages.io" target="_blank" className="editor-link"><strong>info@rocketpages.io</strong></a>.</p>
            </div>
          </div>
        </section>

      </div>
       <Footer />
      </main>
      <CookieConsent />
    </>
  );
}

export default PrivacyPolicy;
